import classNames from 'classnames';

import './styles.css';

export type ArrowType = 'up' | 'left' | 'right' | 'down';

export interface IcArrowProps {
  size?: number;
  type?: ArrowType;
  color?: string;
  className?: string;
}

export function IcArrow({
  size = 10,
  type = 'left',
  color = '#333',
  className = undefined
}: IcArrowProps) {
  return (
    <span
      className={classNames(`ic-arrow ic-arrow-${type}`, className)}
      style={{ width: size, height: size, borderColor: color }}></span>
  );
};

export default IcArrow;
